// Application version information
export const APP_VERSION = 'v1.2.9';
export const BUILD_DATE = '20261016-1900';
export const getVersionString = () => `${APP_VERSION}, Built: ${BUILD_DATE}`;
